import { PartyError } from "../types";

export function createPartyError(serverError: any) {
    return new PartyError(serverError.errorCode, serverError.additionalData, serverError.venueName);
}
